// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608310238/js/" + chunkId + "." + {"44":"0d913fba","225":"cfbe9f04","481":"26334c57","486":"e9341574","770":"3c4112f9"}[chunkId] + ".0.3476831434132589.chunk.js";
};